"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GravityForce = void 0;
const force_1 = require("@/simulator/force");
const settings_1 = require("@/common/settings");
class GravityForce extends force_1.Force {
    constructor(mass) {
        const g = settings_1.Settings.get().getValue("gravity");
        super(0, -mass * g);
    }
    update(self) {
        super.update(self);
        const g = settings_1.Settings.get().getValue("gravity");
        // To update gravity when the user changes the gravity accerlerate in the settings
        this.y = -self.mass * g;
    }
}
exports.GravityForce = GravityForce;
